/**
 * True when the app runs inside the native iOS/Android WebView, detected by the
 * `CiceroneWebApp` user-agent that both native apps inject (iOS
 * `applicationNameForUserAgent`, Android `userAgentString`). Synchronous so it
 * is correct on the first navigation / route guard, independent of Angular init
 * order and of the build environment.
 */
export function isWebViewUserAgent(): boolean {
  return typeof navigator !== 'undefined'
    && !!navigator.userAgent?.includes('CiceroneWebApp');
}
